import React, { useRef } from "react";
import styles from "./style.module.scss";

import AuthenticatedLayout from "../../components/Layout/authenticatedLayout";

import MetricGraph from "../../components/PerformanceMetrics/MetricsGraph";
import { MetricSpec } from "../../types/performanceMetrics";
import PerformanceMetricsDataManager from "../../components/DataManagers/PerformanceMetricsDataManager";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { isEqual } from "lodash";

import { RootState } from "../../state";
import MetricsFiltersBar from "../../components/PerformanceMetrics/MetricsFiltersBar";
import MetricsSaveBar from "../../components/PerformanceMetrics/MetricsSaveBar";

function PerformanceMetricsPage() {
  const scrollTargetRef = useRef<HTMLDivElement>(null);

  const filteredPerformanceMetrics = useSelector(
    (state: RootState) =>
      state.performanceMetrics?.filteredPerformanceMetricsData,
    isEqual,
  );
  const loadingGraphs = useSelector(
    (state: RootState) => state.performanceMetrics?.loadingGraphs,
  );
  const loadingPage = useSelector(
    (state: RootState) => state.performanceMetrics?.loadingPage,
  );
  const isViewingLoadedData = useSelector(
    (state: RootState) => state.performanceMetrics?.isViewingLoadedData,
  );

  const hasData =
    filteredPerformanceMetrics.MetricLaps.length > 0 ||
    Object.keys(filteredPerformanceMetrics.MetricSpec).length > 0;

  return (
    <AuthenticatedLayout
      title={"Performance Metrics"}
      showJaguarLogo={false}
      configOptions={<MetricsSaveBar />}
    >
      <PerformanceMetricsDataManager />

      <div className={styles.container}>
        {!hasData || loadingPage ? (
          <div className={styles.noDataMessage}>
            {loadingGraphs || loadingPage ? (
              <div className={styles.spinner} />
            ) : isViewingLoadedData ? (
              "Please select an event to view saved performance metrics."
            ) : (
              "No live performance metrics data available."
            )}
          </div>
        ) : (
          <>
            <div className={styles.filtersBarWrapper}>
              <MetricsFiltersBar
                metricNames={Object.keys(filteredPerformanceMetrics.MetricSpec)}
              />
            </div>
            <div className={styles.graphsContainer}>
              {loadingGraphs ? (
                <div className={styles.noDataMessage}>
                  <div className={styles.spinner} />
                </div>
              ) : (
                <>
                  <div ref={scrollTargetRef} />
                  {Object.entries(filteredPerformanceMetrics.MetricSpec).map(
                    ([metricName, metricSpec]: [string, MetricSpec]) => (
                      <MetricGraph
                        key={metricName}
                        metricName={metricName}
                        metricSpec={metricSpec}
                        metricLaps={filteredPerformanceMetrics.MetricLaps}
                        scrollTargetRef={scrollTargetRef}
                      />
                    ),
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </AuthenticatedLayout>
  );
}

export default PerformanceMetricsPage;
